import React from 'react';

const CareersPeople: React.FC = () => {
  const people = [
    {
      name: 'Priya Sharma',
      role: 'Cloud Engineer',
      location: 'Pune',
      quote: 'At Global Sansys, I get to work on challenging cloud architectures while mentoring students. The collaborative environment and focus on continuous learning make every day exciting.'
    },
    {
      name: 'Arjun Patel',
      role: 'AI Researcher',
      location: 'Bengaluru',
      quote: 'The opportunity to work on cutting-edge AI projects while contributing to educational programs is unique. I love how we\'re making complex technologies accessible to everyone.'
    },
    {
      name: 'Sneha Reddy',
      role: 'Data Analyst',
      location: 'Remote',
      quote: 'Working remotely at Global Sansys gives me flexibility while being part of impactful projects. The data insights we generate help shape better learning experiences for thousands of students.'
    }
  ];

  return (
    <section className="careers-section careers-people">
      <div className="container">
        <h2 className="section-title">People who love to build and teach</h2>
        <p className="section-subtitle">
          Meet some of the talented individuals who make Global Sansys a great place to work and grow.
        </p>
        
        <div className="people-grid">
          {people.map((person, index) => (
            <div key={index} className="person-card">
              <div className="person-info">
                <div className="person-name">{person.name}</div>
                <div className="person-role">{person.role} • {person.location}</div>
              </div>
              <div className="person-quote">"{person.quote}"</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CareersPeople;